export default {
	_selector: 'figure.image--cut-out',
	_active  : null,
	_images  : [],
	init() {
		this._images = document.querySelectorAll(this._selector);
		if (!this._images.length) {
			return;
		}
		Array.prototype.forEach.call(this._images, image => {
			this._prep(image);
		});
	},
	_onSrcChange(e) {
		const img                    = e.path[0];
		const figure                 = e.path[2];
		const currentSrc             = img.currentSrc;
		figure.style.backgroundImage = `url('${currentSrc}')`;
	},
	_prep(figure) {
		const img        = figure.querySelector('.image__img--cut-out');
		const currentSrc = img.currentSrc;
		if (currentSrc) {
			figure.style.backgroundImage = `url('${currentSrc}')`;
		}
		img.addEventListener('load', this._onSrcChange.bind(this));
	}
};